/* eslint-disable indent */
import React from 'react';
import { useTranslation } from 'react-i18next';

import { SumPerMonthErrorMessage } from './sum-per-month.styles';
import { SumPerMonthErrorProps } from './sum-per-month.types';

export const SumPerMonthError = ({
  errorResponse,
  currentSumErr,
}: SumPerMonthErrorProps) => {
  const { t } = useTranslation();
  const errorCode = errorResponse?.response?.data?.code;

  if (
    errorCode === 'VALIDATION_ERROR' ||
    errorCode === 'TECHNICAL_ERROR' ||
    errorCode === 'BUSINESS_ERROR'
  ) {
    let msg =
      errorCode === 'BUSINESS_ERROR'
        ? t('COMMON:errors.costMoreReduceYourCoverage')
        : t('COMMON:errors.impossibleCalculate');

    switch (currentSumErr) {
      case 'less':
        msg = t('COMMON:errors.coverageLessMin');
        break;
      case 'gt':
        msg = t('COMMON:errors.coverageAboveLimit');
        break;
    }
    return <SumPerMonthErrorMessage>{msg}</SumPerMonthErrorMessage>;
  }

  return null;
};
